module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-2021-4.c6cedb0a.jpg";